import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EtapasCierre } from '@shared/enums/EtapasCierreTurno';
import { TipoComparativa } from '@shared/enums/TipoComparativa';
import { ModalConfirmComponent } from '@shared/generic-modals/modal-confirm.component';
import { CierreTurno } from '@shared/models/cierreTurno/CierreTurno';
import { Comparativa } from '@shared/models/cierreTurno/Comparativa';
import { ComparativaExpendedora } from '@shared/models/cierreTurno/ComparativaExpendedora';
import { Comparativas } from '@shared/models/cierreTurno/Comparativas';
import { TotalProducto } from '@shared/models/cierreTurno/TotalProducto';
import { MessageService } from '@shell/message.service';
import { CierreDiarioService } from '../services/cierre-diario.service';
import { map } from 'rxjs/operators';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-comparativas-cierre-turno',
  templateUrl: './comparativas-cierre-turno.component.html',
  styleUrls: ['./comparativas-cierre-turno.component.scss']
})
export class ComparativasCierreTurnoComponent implements OnInit, OnDestroy {

  cuadroComparativas: Comparativas;
  cierreTurnoContinuo: CierreTurno;

  comparativasTanques15: Comparativa[] = [];
  comparativaTanqueNatural: Comparativa[] = [];
  comparativaAeroespecialidades: Comparativa[] = [];
  comparativaAbastecedora: ComparativaExpendedora[] = [];
  totalProductos15: TotalProducto[] = [];
  totalProductosNatural: TotalProducto[] = [];
  distintosProducto: string[] = [];
  pasarEtapa: boolean = false;

  natural: boolean[]=[];
  grado15: boolean[]=[];

  guardando: boolean = false;
  subscription$: Subscription;

  constructor(private modal: NgbModal, private messageService: MessageService,
    private cierresService: CierreDiarioService, private cierreService: CierreDiarioService) { }

  ngOnInit() {
    this.pasarEtapa = false;
    this.subscription$ = this.cierreService.cierre$.pipe(
      map(cierre => {
        this.cierreTurnoContinuo = cierre ? JSON.parse(JSON.stringify(cierre)) : null;
        const comparativas = new Comparativas();
        comparativas.comparativas = cierre.comparativas ?? [];
        comparativas.comparativasExpendedoras = cierre.comparativasExpendedoras ?? [];
        comparativas.totalesProductos = cierre.totalesProductos ?? [];
        return comparativas;
      })
    ).subscribe(comparativas => {
      this.cuadroComparativas = comparativas;
      this.startPage();
    });
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }

  startPage() {
    this.comparativasTanques15 = this.cuadroComparativas.comparativas.filter(a => a.tipoComparativa == 0);
    this.comparativasTanques15.sort((a , b) => a.nombreContenedor.toLocaleUpperCase() > b.nombreContenedor.toLocaleUpperCase() ? 1 : -1);
    this.comparativaTanqueNatural = this.cuadroComparativas.comparativas.filter(a => a.tipoComparativa == TipoComparativa.TanquesNaturales);
    this.comparativaTanqueNatural.sort((a , b) => a.nombreContenedor.toLocaleUpperCase() > b.nombreContenedor.toLocaleUpperCase() ? 1 : -1);
    this.comparativaAeroespecialidades = this.cuadroComparativas.comparativas.filter(a => a.tipoComparativa == TipoComparativa.Aeroespecialidades);
    this.comparativaAeroespecialidades.sort((a , b) => a.codigoProducto.toLocaleUpperCase() > b.codigoProducto.toLocaleUpperCase() ? 1 : -1);
    this.comparativaAbastecedora = this.cuadroComparativas.comparativasExpendedoras;
    this.comparativaAbastecedora.sort((a , b) => a.nombreExpendedora.toLocaleUpperCase() > b.nombreExpendedora.toLocaleUpperCase() ? 1 : -1);
    this.totalProductos15 = this.cuadroComparativas.totalesProductos.filter( p => p .tipoComparativa == TipoComparativa.Tanque15);
    this.totalProductos15.sort((a , b) => a.nombreProducto.toLocaleUpperCase() > b.nombreProducto.toLocaleUpperCase() ? 1 : -1);
    this.totalProductosNatural = this.cuadroComparativas.totalesProductos.filter( p => p .tipoComparativa == TipoComparativa.TanquesNaturales);
    this.totalProductosNatural.sort((a , b) => a.nombreProducto.toLocaleUpperCase() > b.nombreProducto.toLocaleUpperCase() ? 1 : -1);
    for (const com of this.cuadroComparativas.comparativas) {
      if (com.tipoComparativa != TipoComparativa.Aeroespecialidades) {
        if (!this.distintosProducto.find(a => a == com.codigoProducto + ' - ' + com.nombreProducto)) {
          this.distintosProducto.push(com.codigoProducto + ' - ' + com.nombreProducto);
          this.natural.push(true);
          this.grado15.push(true);
        }
      }
    }
  }

  sumar(dist: string, otro: string): number {
    let cant: number = 0;
    for (const com of this.comparativaTanqueNatural) {
      if (dist == com.codigoProducto + ' - ' + com.nombreProducto) {
        cant += com[otro];
      }
    }
    return cant;
  }

  sumar2(dist: string, otro: string): number {
    let cant: number = 0;
    for (const com of this.comparativasTanques15) {
      if (dist == com.codigoProducto + ' - ' + com.nombreProducto) {
        cant += com[otro];
      }
    }
    return cant;
  }

  continuarCierreTurno() {
    this.guardando = true;
    let stringDiferencias: string = '';
    const comDiferencia: Comparativa[] = [];
    for (const t15 of this.comparativasTanques15) {
      if (t15.diferencia != 0) {
        comDiferencia.push(new Comparativa());
        comDiferencia.push(t15);
        stringDiferencias += t15.codigoContenedor + '. ';
      }
    }
    for (const tn of this.comparativaTanqueNatural) {
      if (tn.diferencia != 0 && !comDiferencia.find(a => a.codigoContenedor == tn.codigoContenedor)) {
        stringDiferencias += tn.codigoContenedor +  '. ';
      }
    }

    for (const aep of this.comparativaAeroespecialidades) {
      if (aep.diferencia != 0 ) {
        stringDiferencias += aep.codigoProducto + '-' + aep.nombreProducto + '. ';
      }
    }

    if (stringDiferencias != '') {
      const modalRef = this.modal.open(ModalConfirmComponent, { centered: true, backdrop: 'static' });
      modalRef.componentInstance.mensaje = 'A los siguientes contenedores y/o aeroespecialidades se le van a realizar ajustes, ' + stringDiferencias + '¿desea continuar?';
      modalRef.componentInstance.titulo = 'Contenedores con diferencias.';
      modalRef.result.then(() => {
          this.pasarEtapa = true;
          this.guardando = false;
          this.cierreTurnoContinuo.etapaActual = EtapasCierre.ParteDiario;
          this.completeStep(EtapasCierre.Comparativas);
      }, () => {
        this.messageService.showErrorMessage('Se canceló la operación del turno.');
        this.guardando = false;
      })
    } else {
      this.pasarEtapa = true;
      this.cierreTurnoContinuo.etapaActual = EtapasCierre.ParteDiario;
      this.completeStep(EtapasCierre.Comparativas);
    }
  }

  completeStep(index: EtapasCierre): void {
    this.cierresService.updateStepProgress(index, this.cierreTurnoContinuo);
  }

  getFiltradoTanquesNatural(dist: string) {
    return this.comparativaTanqueNatural.filter(tn => dist === tn.codigoProducto + ' - ' + tn.nombreProducto);
  }
  getFiltradoTanques15(dist: string) {
    return this.comparativasTanques15.filter(t15 => dist === t15.codigoProducto + ' - ' + t15.nombreProducto);
  }
}
